import { Link } from 'react-router-dom';

const stats = [
  { value: '150+', label: 'Projecten Voltooid' },
  { value: '8+', label: 'Jaar Ervaring' },
  { value: '100%', label: 'Klanttevredenheid' },
  { value: '3', label: 'Specialisaties' },
];

const ServiziStats = () => {
  return (
    <section className="py-20 bg-gray-900">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-10 mb-16">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-4xl lg:text-5xl font-bold text-amber-300 mb-2" style={{ fontFamily: 'Playfair Display, serif' }}>
                {stat.value}
              </div>
              <div className="text-sm text-gray-400 uppercase tracking-wider">{stat.label}</div>
            </div>
          ))}
        </div>

        <div className="border-t border-gray-700 pt-14 flex flex-col lg:flex-row items-center justify-between gap-8">
          <div>
            <h3 className="text-2xl lg:text-3xl font-bold text-white mb-2" style={{ fontFamily: 'Playfair Display, serif' }}>
              Klaar om uw renovatie te starten?
            </h3>
            <p className="text-gray-400 text-sm">
              Vraag vandaag nog een gratis offerte aan — wij reageren binnen 24 uur.
            </p>
          </div>
          <Link
            to="/offerte"
            className="inline-flex items-center gap-2 bg-amber-300 text-gray-900 px-8 py-4 rounded-lg text-sm font-bold hover:bg-amber-400 transition-colors whitespace-nowrap cursor-pointer flex-shrink-0"
          >
            Gratis Offerte Aanvragen
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ServiziStats;
